"use client";

import { useEffect, useState } from "react";

/**
 * Mode compact des petits écrans (< 420 px).
 *
 * Le seuil était défini en propre dans `welcome-studio-card`. L'écran de compte
 * en a besoin du même, et deux copies du même point de rupture finissent
 * toujours par diverger — c'est le genre d'écart qu'on ne remarque qu'en
 * regardant les deux surfaces côte à côte sur un téléphone, donc jamais.
 *
 * Le chrome de la carte ne change pas ; seuls les marges, l'échelle
 * typographique et la taille de saisie diminuent pour tenir sur 360 px sans
 * défilement horizontal.
 */
export function useIsCompact(): boolean {
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    const query = window.matchMedia("(max-width: 419px)");
    const update = () => setCompact(query.matches);

    update();
    query.addEventListener("change", update);

    return () => query.removeEventListener("change", update);
  }, []);

  return compact;
}
